
export default class MouseClickSensor {

    lastClickTime = 0;
    lastClickX = 0;
    lastClickY = 0;

    constructor(onClick, onDoubleClick) {
        this.onClick = onClick;
        this.onDoubleClick = onDoubleClick;
    }

    down(e) {
        this.downTime = new Date().getTime();
        this.downX = e.screenX;
        this.downY = e.screenY;
    }

    up(e) {

        if (!this.downX)
            return;

        this.upTime = new Date().getTime();
        const duration = this.upTime - this.downTime;
        if (duration > 400)
            return;

        this.upX = e.screenX;
        this.upY = e.screenY;

        let dx = this.upX - this.downX;
        let dy = this.upY - this.downY;

        if (Math.abs(dx) > 2 || Math.abs(dy) > 2)
            return;

        const thisTime = new Date().getTime();
        const dbc = thisTime - this.lastClickTime;
        if (dbc > 400) {
            if (this.onClick) {
                this.onClick(e);
                // console.log("单击");
            }

            this.lastClickTime = thisTime;
            this.lastClickX = this.upX;
            this.lastClickY = this.upY;
            return;
        }

        dx = this.upX - this.lastClickX;
        dy = this.upY - this.lastClickY;

        if (Math.abs(dx) <= 2 && Math.abs(dy) <= 2 && this.onDoubleClick) {
            this.onDoubleClick(e);
            // console.log("双击");
        }
        else if (this.onClick) {
            this.onClick(e);
            // console.log("单击");
        }

        this.lastClickTime = thisTime;
        this.lastClickX = this.upX;
        this.lastClickY = this.upY;
    }
}
